import type { CustomizationHiddenMode } from "@tiendanube/nube-sdk-internal-types";

/**
 * Every value `hidden` accepts. The union in the types is the surface; this
 * is the same list at runtime, which is what the options coming off the
 * worker wire are actually checked against.
 */
const HIDDEN_MODES: readonly CustomizationHiddenMode[] = [
	"always",
	"mobile",
	"desktop",
	"never",
];

/** True when `input` is one of the visibility modes. */
export function isHiddenMode(input: string): input is CustomizationHiddenMode {
	return HIDDEN_MODES.some((mode) => mode === input);
}

/**
 * Why `input` cannot be used as a visibility mode, or `null` when it can.
 *
 * Fails closed, like the colour rules: a mode the main thread does not
 * recognize has no class to apply, so applying it would be a silent no-op
 * that the app reads back as a success. The accepted values are named in the
 * reason because the app never sees this SDK's union, only this sentence.
 */
export function hiddenModeRefusal(input: string): string | null {
	if (isHiddenMode(input)) return null;
	return `"${input}" is not a visibility mode; use "always", "mobile", "desktop" or "never"`;
}
